import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { AddClosedExceptionModule } from '../add-closed-exception/add-closed-exception.module';
import { ClosedExceptionsComponent } from './closed-exceptions.component';
import { RegisterModule } from 'src/app/common-components/register/register.module';

@NgModule({
   declarations: [ClosedExceptionsComponent],
   exports: [ClosedExceptionsComponent],
   imports: [
      DragDropModule,
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      MatIconModule,
      MatTooltipModule,
      RegisterModule,
      MatButtonModule,
      MatSlideToggleModule,
      MatCheckboxModule,
      MatMenuModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      ScrollingModule,
      LcsCallStatePipeModule,
      AddClosedExceptionModule,
   ],
})
export class ClosedExceptionsModule {}
